module.exports = __webpack_public_path__ + "img/05.c415e458.png";